import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const MENUS = [
  {
    name: "Cafe food",
    note: "All-day cafe classics",
    img: "https://images.unsplash.com/photo-1621523132966-19f711d565d1?crop=entropy&cs=srgb&fm=jpg&q=85",
    href: "https://deliveroo.co.uk/menu/London/north-harrow/the-moon-cafe-headstone-gardens?day=today&geohash=gcpv2qf0vtdx&time=ASAP",
    testid: "delivery-cafe-link",
  },
  {
    name: "Sweet delights",
    note: "Cakes & sweet treats",
    img: "https://images.unsplash.com/photo-1637944220604-c5f28faac604?crop=entropy&cs=srgb&fm=jpg&q=85",
    href: "https://deliveroo.co.uk/menu/London/north-harrow/the-moon-sweet-delights?day=today&geohash=gcpv2qf0vtdx&time=ASAP",
    testid: "delivery-sweet-link",
  },
  {
    name: "Burgers",
    note: "From the grill",
    img: "https://images.unsplash.com/photo-1651993841930-946a700c1524?crop=entropy&cs=srgb&fm=jpg&q=85",
    href: "https://deliveroo.co.uk/menu/London/north-harrow/the-moon-burgers?day=today&geohash=gcpv2qf0vtdx&time=ASAP",
    testid: "delivery-burgers-link",
  },
];

export default function Delivery() {
  return (
    <section id="order" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <motion.p
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.8, ease: EASE }}
              className="font-sans text-xs uppercase tracking-[0.35em] text-sage"
            >
              Food delivery
            </motion.p>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
              className="mt-5 font-serif text-4xl font-medium leading-tight text-cream sm:text-5xl md:text-6xl"
            >
              Order in, straight from The Moon.
            </motion.h2>
          </div>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease: EASE, delay: 0.2 }}
            className="max-w-sm font-sans text-base font-light leading-relaxed text-cream-dim/80 md:text-lg"
          >
            Three menus live on Deliveroo — tap a card and it's at your door.
          </motion.p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:mt-20 md:grid-cols-3">
          {MENUS.map((m, i) => (
            <motion.a
              key={m.name}
              href={m.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={m.testid}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.9, ease: EASE, delay: i * 0.12 }}
              className="group relative block h-[380px] overflow-hidden border border-line bg-ink2 transition-colors duration-500 hover:border-sage/50 md:h-[460px]"
            >
              <img
                src={m.img}
                alt={m.name}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover opacity-80 transition-all duration-700 group-hover:scale-105 group-hover:opacity-100"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/35 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-8">
                <div>
                  <p className="font-sans text-[10px] uppercase tracking-[0.3em] text-sage">
                    Delivered via Deliveroo
                  </p>
                  <h3 className="mt-3 font-serif text-3xl font-medium text-cream md:text-4xl">
                    {m.name}
                  </h3>
                  <p className="mt-2 font-sans text-sm font-light text-cream-dim/75">{m.note}</p>
                </div>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-sage/40 text-sage transition-all duration-300 group-hover:bg-cream group-hover:text-ink">
                  <ArrowUpRight className="h-4 w-4" />
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
